import UpdatePassword from "../components/configuration/users/UpdatePassword";

const UpdatePasswordPage = () => {
    return (
        <UpdatePassword />
    );
};

export default UpdatePasswordPage;  
